/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1TagDropdown200,
  GetApiV1TagDropdown401,
  GetApiV1TagDropdown500,
  GetApiV1TagDropdownQueryResponse,
} from "../../types/tagRegistroController/GetApiV1TagDropdown.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1TagDropdown200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1TagDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1TagDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1TagDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1TagDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1TagDropdown500>;

export const getApiV1TagDropdownQueryResponseSchema = z.lazy(
  () => getApiV1TagDropdown200Schema,
) as unknown as ToZod<GetApiV1TagDropdownQueryResponse>;
